(() => {
  document.querySelector('.copilot-badge-button').addEventListener('click', () => {
    const element = document.querySelector('.copilot-chat');
    if (!element.src) {
      element.src = element.dataset.src;
    }
  });
})();
